export const DEMO_ANALYSIS_DRAWER_VALUE = 'demo-analysis';
